.s-products-slider{
  &-wrapper{

  }
  &-slider{

  }
  &-card{

  }
}